import { ILabelConfig } from 'src/common/types/LabelsTypes';

interface ISessionWithLabels {
	app: Array<string> | string;
	app_id: Array<string> | string;
	mobile_kit?: Array<string | null> | string | null;
	app_version?: Array<string> | string;
	device_manufacturer?: Array<string> | string;
	device_model?: Array<string> | string;
	device_type?: Array<string> | string;
	os?: Array<string> | string;
	os_version?: Array<string> | string;
	app_build_number?: Array<string> | string;
	product_version?: Array<string> | string;
}

type CustomFieldEntry = Array<string | null>;

const toArray = (value: Array<string> | string | undefined): string[] => {
	if (!value) {
		return [];
	}
	return Array.isArray(value) ? value : [value];
};

const hasMobileKit = (mobileKit: Array<string | null> | string | null | undefined): boolean => {
	const values = toArray(mobileKit);
	return values.some((value) => value === 'true');
};

export const buildMobileLabels = (session: ISessionWithLabels): string[] => {
	const labels = [
		...toArray(session.app).map((item) => `AppName: ${item}`),
		...toArray(session.app_id).map((item) => `AppId: ${item}`),
		...toArray(session.app_version).map((item) => `AppVersion: ${item}`),
		...toArray(session.device_manufacturer).map((item) => `DeviceManufactured: ${item}`),
		...toArray(session.device_model).map((item) => `DeviceModel: ${item}`),
		...toArray(session.device_type).map((item) => `DeviceType: ${item}`),
		...toArray(session.os).map((item) => `OsType: ${item}`),
		...toArray(session.os_version).map((item) => `OsVersion: ${item}`),
		...toArray(session.app_build_number).map((item) => `AppBuildNumber: ${item}`),
		...toArray(session.product_version).map((item) => `ProductVersion: ${item}`)
	];

	if (hasMobileKit(session.mobile_kit)) {
		labels.push('MobileKit');
	}

	return labels;
};

export const transformLabels = (
	customFields: CustomFieldEntry[],
	labels: string[] = [],
	labelsConfig?: ILabelConfig[]
): string[] => {
	const baseLabels = labels.filter(Boolean);

	if (!customFields?.length) {
		return baseLabels;
	}

	const customLabelsRaw: string[] = [];
	const customLabelsDisplayNames: string[] = [];
	const labelConfigMap = labelsConfig
		? new Map(labelsConfig.map((label) => [label.key, label]))
		: null;

	for (const [labelKey, valueKey] of customFields) {
		if (!labelKey || !valueKey) {
			continue;
		}

		customLabelsRaw.push(`${labelKey}: ${valueKey}`);

		if (labelConfigMap) {
			const labelConfig = labelConfigMap.get(labelKey);
			const displayName = labelConfig?.options?.find((opt) => opt.key === valueKey)?.name;

			if (displayName) {
				customLabelsDisplayNames.push(displayName);
			}
		}
	}

	return [...baseLabels, ...customLabelsRaw, ...customLabelsDisplayNames];
};
